import { API, graphqlOperation } from "aws-amplify";

const AmplifyAPIService = {};

//GraphQL Query
AmplifyAPIService.fetchModel = async (query, auth) => {
  return await API.graphql({
    query: query,
    authMode: auth,
  });
};

AmplifyAPIService.fetchModelFilter = async (query, filter) => {
  return await API.graphql({ query: query, variables: { filter: filter } });
};

AmplifyAPIService.getModel = async (query, ID) => {
  return await API.graphql({
    query: query,
    variables: { id: ID },
  });
};

AmplifyAPIService.getModelFilter = async (query, variables, auth) => {
  return await API.graphql({
    query: query,
    variables: variables,
    authMode: auth,
  });
};

//GraphQL Mutations
AmplifyAPIService.addModel = async (mutation, input) => {
  return await API.graphql(graphqlOperation(mutation, { input: input }));
};

AmplifyAPIService.updateModel = async (mutation, input) => {
  return await API.graphql(graphqlOperation(mutation, { input: input }));
};

AmplifyAPIService.deleteModel = async (mutation, ID) => {
  return await API.graphql({
    query: mutation,
    variables: { input: { id: ID } },
  });
};

AmplifyAPIService.mutationFunction = async (query, variables, auth) => {
  return await API.graphql({
    query: query,
    variables: variables,
    authMode: auth,
  });
};

//GraphQL Subscriptions

AmplifyAPIService.subscribeModel = async (model) => {
  return await API.graphql(graphqlOperation(model));
};

export default AmplifyAPIService;
